import type { Me } from '@bk/contracts';
import { navigate } from '../lib/router';
import { PageTitle } from '../ui';
import { AccountPage, AssistantsCard } from './AccountPage';
import { TenantsPage } from './TenantsPage';

const SECTIONS = [
  ['account', 'Account e sicurezza'],
  ['assistenti', 'Collega la tua AI'],
  ['aziende', 'Le tue aziende'],
] as const;

/**
 * Impostazioni dell'utente (ADR 0118), dal suo nome nella barra in alto: account e verifica in due passaggi, assistenti
 * AI collegati via MCP, aziende (aggiungere, riprovare, eliminare). `base` = dove stanno (dentro un'azienda o no).
 */
export function SettingsPage({ me, section, base }: { me: Me; section?: string; base: string }) {
  const current = SECTIONS.find(([k]) => k === section)?.[0] ?? 'account';
  return (
    <>
      <PageTitle title="Impostazioni" subtitle={`${me.name} · ${me.email}`} />
      <div className="mb-5 flex gap-1 overflow-x-auto border-b border-black/10">
        {SECTIONS.map(([key, label]) => (
          <button
            key={key}
            className={`-mb-px shrink-0 border-b-2 px-3 py-2 text-sm ${current === key ? 'border-accent font-medium text-ink' : 'border-transparent text-ink/60 hover:text-ink'}`}
            onClick={() => navigate(`${base}/${key}`)}
          >
            {label}
          </button>
        ))}
      </div>
      {current === 'account' ? <AccountPage me={me} /> : current === 'assistenti' ? <AssistantsCard /> : <TenantsPage />}
    </>
  );
}
